import angular = require("angular");
import TPL = require("templates");
import {EventType, CostType} from "../../models/data";

export class SearchDirective {

  template = TPL.contentDirectives.search;
  scope = {
    params: "=params"
  };

  static factory() {
    var tmp = () => new SearchDirective();
    return tmp;
  }
}

export class SearchFilterDirective {

  template = TPL.contentDirectives.searchFilter;
  scope = {
    params: "=params"
  };

  link;

  constructor(session) {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          session: session,
          eventTypeOptions: [
            EventType.ALL,
            EventType.PUBLIC,
            EventType.MANUAL,
            EventType.PRIVATE
          ],
          costTypeOptions: [
            CostType.ALL,
            CostType.FREE,
            CostType.PAID
          ],
          availableDates : [
            {id: "1",date: new Date(1970,1,1,0,0,0,0),label: "All"},
            {id: "4",date: new Date(2016,9,19,19,0,0,0),label: "10/19/2016"}
          ],
          minEventDate: new Date(2016,9,24,19,0,0,0),
          getDateLabel() {
            if (scope.params.filter.minDate){
              var dateLabel;
              if (scope.params.filter.minDate.getFullYear() == 1970){
                dateLabel = "All";
                scope.params.filter.minDate = new Date();
                scope.params.filter.maxDate = undefined;
              } else {
                dateLabel = (scope.params.filter.minDate.getMonth() + 1) + "/" + scope.params.filter.minDate.getDate() + "/" + scope.params.filter.minDate.getFullYear();
              }
            }
            return dateLabel;
          }

        };
    }

  }


  static factory() {
    var tmp = (a) => new SearchFilterDirective(a);
    tmp.$inject = ["session"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/search.ts
 **/